import { Injectable } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { IListingSetup } from '@df/catalog-ui/listing/listing';
import { IProductListingConfig } from '@df/catalog-ui/listing/product-listing';
import { ProductListingFactory } from '@df/catalog-ui/listing/product-listing.factory';
import { ProductListingDecorator } from './product-listing.decorator';

@Injectable({ providedIn: 'root' })
export class ProductListingFactoryDecorator extends ProductListingFactory {
    override create<T extends Product = Product<IProductDataV2>>(
        config: Partial<IProductListingConfig>,
        models: T[] | number[],
        setup: IListingSetup<T> = {}
    ): ProductListingDecorator<T> {
        return new ProductListingDecorator<T>(config, models, setup);
    }
}
